import { Location } from '@angular/common';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class HistoryService {
	private router = inject(Router);
	private location = inject(Location);
	private destroyRef = inject(DestroyRef);

	private history: string[] = [];

	constructor() {
		this.router.events
			.pipe(
				filter((e): e is NavigationEnd => e instanceof NavigationEnd),
				takeUntilDestroyed(this.destroyRef)
			)
			.subscribe((e) => {
				this.history.push(e.urlAfterRedirects);
			});
	}

	get canGoBack() {
		return this.history.length > 1;
	}

	goBack() {
		this.history.pop();
		if (this.history.length > 0) {
			this.location.back();
		} else {
			this.router.navigateByUrl('/');
		}
	}
}
